
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { DebounceMixin, VuetifyMixin, BAIconsMixin } from '../../mixins';
import { getShortMonthName, getShortWeekdayName, getDate, getTime } from '../../helpers';
import { getDefaultEventTypes } from '../../helpers/default-event-types';
import { teameventtype } from '@/pipes/teameventtype.pipe';
import { TeamEventTypeData } from '@/../types/interfaces';
import { CalendarEventModel } from '../../models/calendar/CalendarEventModel';

interface EventBucket{
	label: string,
	events: CalendarEventModel[],
}

@Component
export default class EventsAgenda extends Mixins(DebounceMixin, VuetifyMixin, BAIconsMixin){
	@Prop({ default: false, type: Boolean }) includePast: boolean;
	@Prop({ default: 300 }) height: number;
	@Prop({ default: [] }) events: CalendarEventModel[];

	eventTypes: TeamEventTypeData[] = getDefaultEventTypes();

	eventColor(event: CalendarEventModel): string{
		const t = this.eventTypes.find(x => x.name === event.eventType);
		return this.getColor(t ? t.color : 'baColorVibrantBlue');
	}
	eventTypeLabel(event: CalendarEventModel): string{
		return event.eventType ? teameventtype(event.eventType) : 'Event';
	}
	timeRange(event: CalendarEventModel): string{
		if((event as any).isAllDay) return 'All day';
		if(event.start && event.end) return `${getTime(event.start)} - ${getTime(event.end)}`;
		if(event.start) return getTime(event.start);
		return '';
	}
	goingCount(event: CalendarEventModel): number{
		return (event.participants || []).filter(p => p.rsvp === 'Yes').length;
	}

	$refs:{
		agendaContainer: HTMLDivElement;
	}

	eventClicked(event: CalendarEventModel): void{
		this.$emit('click:event', {
			event, 
			day: {
				date: `${event.start.getUTCFullYear()}-${event.start.getUTCMonth() + 1}-${event.start.getUTCDate()}` 
			} 
		});
	}

	scrollContentPadding: number = 8;
	scrollContentHeight: number = 0;
	debounceResize(): void{
		this.debounceCallback('onResize', () => this.onResize(), 100);
	}
	onResize(): void {
		this.scrollContentHeight = this.$refs['agendaContainer'].clientHeight;
	}
	get ScrollContainerStyle(): Record<string, string>{
		return {
			padding: `${this.scrollContentPadding}px`,
		};
	}
	get ScrollContentHeightLessPadding(): number{
		return Math.max(0,this.scrollContentHeight - (this.scrollContentPadding*2));
	}
	get ScrollContentStyle(): Record<string, string>{
		return {
			'height': `${this.ScrollContentHeightLessPadding}px`,
			'overflow': 'hidden',
			'overflow-y': 'auto',
		};
	}
	mounted(): void{
		this.onResize();
	}

	formatDate(date: Date): string{
		return `${getShortWeekdayName(date, true)}, ${getShortMonthName(date, true)} ${getDate(date, true)}`;
	}

	get EventBuckets(): EventBucket[]{
		const events: CalendarEventModel[] = this.events.slice().sort((a,b) => {
			return +(a.start) - +(b.start);
		});
		// Group by day, one bucket per distinct day (avoids duplicate day headers).
		const buckets: EventBucket[] = [];
		const seen = new Set<string>();
		for(const event of events){
			const label = this.formatDate(event.start);
			if(seen.has(label)) continue;
			seen.add(label);
			buckets.push({
				label,
				events: events.filter(e => this.formatDate(e.start) === label),
			});
		}
		return buckets;
	}

}
